import { useState } from "react";
import useQueries from "../useQueries";
import { getDate } from "@/shared/utils/getDate";
import { buildQuery } from "@/shared/utils/buildQuery";
import useData from "../useData";
import { API_URL } from "@/shared/utils/API_URL";

const useItemSales = () => {
    const queries = useQueries();
    const [displayReport, setDisplayReport] = useState('Standard Layout');
    const [dialog, setDialog] = useState({
        open: false,
        layoutType: ''
    });
    const onCloseDialog = () => {
        setDialog((prev) => ({ ...prev, open: !dialog.open }))
    }

    const [date, setDate] = useState({
        from: getDate(),
        to: getDate()
    });
    const q = queries
        ? buildQuery(queries?.itemSalesQuery, { fromDate: `${date.from} 00:00:00`, endDate: `${date.to} 23:59:59` })
        : '';

    const { fetchedData, loading } = useData({
        apiUrl: API_URL,
        q: q,
        t: "sel",
        dependency: [q, date.from, date.to],
    });
    const itemSales = fetchedData?.data?.result || [];

    const handleQuickSelect = (type: string, dateType: string) => {
        const formatDate = (date: any) => {
            const year = date?.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        let start = new Date();
        let end = new Date();
        const now = new Date();
        if (type == 'today') {
            start = new Date();
            end = new Date();
        }
        if (type == 'yesterday') {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            start = yesterday;
            end = yesterday;
        }
        else if (type === 'current_month') {

            start = new Date(now.getFullYear(), now.getMonth(), 1);
            end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        }
        else if (type === 'last_month') {
            start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            end = new Date(now.getFullYear(), now.getMonth(), 0);
        }
        setDate(prev => ({ ...prev, from: formatDate(start) }));
        setDate(prev => ({ ...prev, to: formatDate(end) }));
    }

    const groupedData = () => {
        const grouped: any[] = [];
        itemSales.forEach((item: any) => {
            const existing = grouped.find(g =>
                g.item_name === item.item_name &&
                g.item_price === item.item_price
            );

            if (existing) {
                existing.total_quantity += Number(item.item_quantity);
                existing.details.push(item);
                existing.rowSpan = existing.details.length;
            } else {
                grouped.push({
                    ...item,
                    total_quantity: Number(item.item_quantity),
                    rowSpan: 1,
                    details: [item]
                });
            }
        });
        return grouped?.sort((a, b) => a.item_id - b.item_id);;
    };
    return {
        handleQuickSelect,
        displayReport,
        setDisplayReport,
        groupedData,
        loading, 
        q,
        date,
        setDate,
        dialog,
        setDialog,
        itemSales,
        onCloseDialog
    }
}

export default useItemSales